export default "__VITE_ASSET__CGdrHcuj__"